import Agendamento from "@/views/agendamento.vue";
import Convenios from "@/views/convenio.vue";
import Especialidades from "@/views/especialidade.vue";
import Clinica from "@/views/clinica.vue";
import Agenda from "@/views/agendar.vue";
import Pacientes from "@/views/pacientes.vue";
import Profissionais from "@/views/profissionais.vue";
import Confirmacao from "@/views/confirmacao.vue";
import onBeforeEnter from "@/core/routerHelper";
import Store from "@/store.js";

export default [
  {
    path: "/exame/:organizationId",
    name: "exame",
    component: Agendamento,
    children: [
      {
        path: "convenio",
        name: "exame_convenio",
        component: Convenios,
        beforeEnter: onBeforeEnter(1)
      },
      {
        path: "procedimento",
        name: "exame_procedimento",
        component: Especialidades,
        beforeEnter: onBeforeEnter(2)
      },
      {
        path: "clinica",
        name: "exame_clinica",
        component: Clinica,
        beforeEnter: onBeforeEnter(3)
      },
      {
        path: "agendar",
        name: "exame_agendar",
        component: Agenda,
        beforeEnter: onBeforeEnter(4)
      },
      {
        path: "profissional",
        name: "exame_profissional",
        component: Profissionais,
        beforeEnter: onBeforeEnter(5)
      },
      {
        path: "paciente",
        name: "exame_paciente",
        component: Pacientes,
        beforeEnter: (to, from, next) => {
          localStorage.setItem("telemedicina", to.query.telemedicina || localStorage.getItem("telemedicina"));
          if (!Store.getters.token) {
            Store.dispatch("set_to", to);
            Store.dispatch("set_modalLogin", true);
          }else if(Store.getters.token) {
            Store.commit("set_actualstep", 6);
            next();
          }
        }
      },
      {
        path: "confirmacao",
        name: "exame_confirmacao",
        component: Confirmacao,
        beforeEnter: (to, from, next) => {
          if (Store.getters.token === "") {
            Store.dispatch("set_to", to);
            Store.dispatch("set_modalLogin", true);
          }

          Store.commit("set_actualstep", 7);
          next();
        }
      }
    ]
  }
];
